import { Box } from '@mui/material';
import { teal } from "@mui/material/colors";

// Reusable Status component
const Status = ({ colors, status }) => {
    const background = teal[700];
    const color = colors[status] || background;

    return (
        <Box sx={{ 
            height: '20px', 
            width: "100px", 
            textAlign: 'center', 
            display: "inline", 
            fontSize: 10, 
            background: color, 
            borderRadius: '5px', 
            color: 'white', 
            padding: "4px 7px", 
            fontWeight: 'bold' 
        }}>
            {status.replace(/_/g, " ")}
        </Box>
    )
}

// For Vehicle Deployment Status
const DeploymentStatus = ({ status }) => {
    const colors = {
        "COMPLETED": "#3ba272",
        "PUBLISHED": "#5470c6",
        "SCHEDULED": "#73c0de",
        "NOT_PUBLISHED": "#fc8452",
        "EXPIRED": "#f44336",
        "CANCELED": "#ee6666"
    };

    return <Status colors={colors} status={status} />
}

// For Vehicle Deployment Job Execution Status
export const JobExecutionStatus = ({ status }) => {
    const colors = {
        "NOT_PUBLISHED": "#949494ff",   // grey – not yet published
        "SCHEDULED": "#90caf9",       // Soft blue – scheduled but not queued
        "QUEUED": "#5470c6",          // Calm blue – waiting to be picked up
        "IN_PROGRESS": "#73c0de",     // Light blue – actively executing
        "SUCCEEDED": "#3ba272",       // Green – success
        "FAILED": "#f44336",          // Red – failed, retryable
        "TIMED_OUT": "#ff9800",       // Orange – timed out, retryable
        "REJECTED": "#fc8452",        // Coral – rejected by device, terminal
        "REMOVED": "#9e9e9e",         // Grey – removed from queue, terminal
        "CANCELED": "#ee6666",        // Soft red – canceled by AWS IoT, terminal
        "EXPIRED": "#795548"          // Brown – expired due to time, terminal
    };

    return <Status colors={colors} status={status} />
}

export default DeploymentStatus;